export enum PermissionRuleCheckStrategiesEnum {
    Union,
    Intersect
}
